// Configuration for Halal Property Verification Tool - Supabase Edition
export const config = {
  // Supabase configuration
  supabaseUrl: process.env.REACT_APP_SUPABASE_URL || 'https://your-project-ref.supabase.co',
  supabaseAnonKey: process.env.REACT_APP_SUPABASE_ANON_KEY || 'your-supabase-anon-key',

  // Polling configuration
  pollingInterval: parseInt(process.env.REACT_APP_POLLING_INTERVAL || '5000', 10), // 5 seconds for Supabase

  // Debug mode
  debug: process.env.REACT_APP_DEBUG === 'true',

  // Supabase Edge Function endpoints
  endpoints: {
    initiateCall: '/functions/v1/initiate-call',
    getCalls: '/functions/v1/get-calls',
    analyzeTranscript: '/functions/v1/analyze-transcript',
    checkCallStatus: '/functions/v1/check-call-status',
    deleteCall: '/functions/v1/delete-call',
    bulkInitiate: '/functions/v1/bulk-initiate',
    parseCsv: '/functions/v1/parse-csv',
  },
};

export default config;
